var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card-title",
            {
              staticClass: "pb-0 pt-0"
            },
            [_vm._v(" Service Status ")]
          )
        ],
        1
      ),
      _vm._l(_vm.itemsSorted, function(item) {
        return _c(
          "v-col",
          {
            key: item.id,
            attrs: {
              cols: "12"
            }
          },
          [
            _c("down-time-item", {
              attrs: {
                item: item
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }